import { FC } from 'react'
const Dashboard : FC = () => {
    return (
         <div>Startseite</div>
    )
}
export default Dashboard
